import type { SomethingWithState } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class WallCrack extends PhysicalThing implements SomethingWithState {
	static key = "WallCrack";
	private stage: number;

	constructor(xy: XY, stage: number) {
		super(xy, false);
		this.stage = stage;
	}

	getZOrder(): number {
		return ZOrder.SCENARIO + 1;
	}

	isHideUnderneath(): boolean {
		return false;
	}

	getState(): number {
		return this.stage;
	}

	setState(stage: number): void {
		this.stage = stage;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), stage: this.stage };
	}

	static deserialize(data: any): WallCrack {
		const w = new WallCrack(deserializeXY(data.xy), data.stage);
		w.visualId = data.visualId;
		return w;
	}
}
